export enum FileFormatEnum {
    LeaveImportController = ".xlsx",
    AttributeImportController = ".xlsx",
    StaffImportController = ".xlsx",
    LOPDController = ".doc,.docx,.pdf",
    CitationController = ".doc,.docx,.pdf",
    MedicoController = ".pdf",
    EmpresaController = ".pdf",
    TrabajadorControllerDocumento = ".pdf",
    TrabajadorControllerInformeMedico = ".pdf",
    TrabajadorDocumentosNoMedico = ".pdf",
    LeaveImportControllerTS = "XLSX",
    AttributeImportControllerTS = "XLSX",
    StaffImportControllerTS = "XLSX",
    LOPDControllerTS = "DOC,DOCX,PDF",
    CitationControllerTS = "DOC,DOCX,PDF",
    MedicoControllerTS = "PDF",
    EmpresaControllerTS = "PDF",
    TrabajadorControllerDocumentoTS = "PDF",
    TrabajadorControllerInformeMedicoTS = "PDF",
    TrabajadorDocumentosNoMedicoTS = "PDF",
}
